var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4167 5C16.3833 4.71667 18.4667 6.86667 19.0667 9.83333C19.6667 12.7833 18.5833 15.4167 16.6167 15.7167C14.6667 16.0167 12.5667 13.8667 11.95 10.9C11.3333 7.95 12.45 5.31667 14.4167 5ZM26.3333 5C28.3167 5.31667 29.4167 7.95 28.8333 10.9C28.2 13.8667 26.1167 16.0167 24.15 15.7167C22.1667 15.4167 21.0833 12.7833 21.7 9.83333C22.3 6.86667 24.3833 4.71667 26.3333 5ZM5.50001 12.6667C7.40001 11.85 9.98334 13.3333 11.3333 15.9167C12.6 18.55 12.1667 21.3167 10.2833 22.1333C8.40001 22.95 5.83334 21.4833 4.51667 18.8667C3.20001 16.25 3.66667 13.4667 5.50001 12.6667ZM35.5 12.6667C37.3333 13.4667 37.8 16.25 36.4833 18.8667C35.1667 21.4833 32.6 22.95 30.7167 22.1333C28.8333 21.3167 28.4 18.55 29.6667 15.9167C31.0167 13.3333 33.6 11.85 35.5 12.6667ZM32.7167 30.6333C32.7833 32.2 31.5833 33.9333 30.15 34.5833C27.1667 35.95 23.6333 33.1167 20.3167 33.1167C17 33.1167 13.4333 36.0667 10.5 34.5833C8.83334 33.7667 7.68334 31.6 7.90001 29.8C8.20001 27.3167 11.1833 25.9833 12.95 24.1667C15.3 21.8167 16.9667 17.4 20.3167 17.4C23.65 17.4 25.4167 21.75 27.6667 24.1667C29.5167 26.2 32.6 27.9167 32.7167 30.6333Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.59d1a402.svg";
export { ForwardRef as ReactComponent };